import { Component, OnInit, Output, EventEmitter, Input, ViewChild, ElementRef, OnDestroy } from '@angular/core';
import { SharedService } from '../../../shared/providers/shared.service';
import { OfferService } from '../../../shared/providers/offer.service';
import { Trade1031Service } from '../../../shared/providers/Trade1031.service';
import { ToastService } from '../../../shared/providers/toast.service';
import { IChartData, InnerData } from '../../../shared/models/IChartData';
import { ValidationService } from '../../../shared/providers/validation.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ITaskSummary } from '../../../shared/models/DashboardDataOModel';
import * as Highcharts from 'highcharts';
import * as EXports from 'highcharts/highstock';
import * as moment from 'moment';
import { AuthenticationService } from '../../../shared/auth/authentication.service';
declare var require: any;
//require('highcharts/modules/map')(Highcharts);
if (typeof Highcharts === 'object') {

  let Boost = require('highcharts/modules/boost');
  let noData = require('highcharts/modules/no-data-to-display');
  let More = require('highcharts/highcharts-more');

  Boost(Highcharts);
  noData(Highcharts);
  More(Highcharts);
  noData(Highcharts);
}

@Component({
  selector: 'app-time-remaining-info',
  templateUrl: './time-remaining-info.component.html',
  styleUrls: ['./time-remaining-info.component.css']
})
export class TimeRemainingInfoComponent implements OnInit {

  constructor(private Shared: SharedService, private authService: AuthenticationService, private router: Router, private Validation: ValidationService, private offerService: OfferService, private activatedRoute: ActivatedRoute, private Trade1031: Trade1031Service, private Toast: ToastService) {
    //this.initializeChart();
  }
  selectedExchange: number = 0;
  offerGuid = '';
  chartDataResponse: IChartData[];
  chartData = [];
  user: any;
  //chart = new Chart();
  startDate: any;
  endDate: any;
  currentDate: any;
  date_45: any;
  Aday: number = 24 * 3600 * 1000;
  options: Object;
  @Output() closeDate = new EventEmitter();
  @Output() changeActiveTab = new EventEmitter();
  TaskSummary: ITaskSummary[];
  //initializeChart() {
  //    let options = new Chart({
  //        title: {
  //            text: ""
  //        }
  //        , credits: {
  //            enabled: false
  //        }
  //    });
  //    this.chart = options;
  //}

  @Input() exchangeSelected: number = 0;
  @Input() IsConnectedExchange: boolean = false;
  blockChartRebind = true;

  @ViewChild('chartContainer') chartContainer: ElementRef;


  changeOfferStatus(leadId) {
    this.offerService.ChangeLeadChecklistTaskStatus(leadId, 2252, this.user.Id).subscribe(response => {
      if (response) {
        this.Toast.addToast({ title: 'Success', msg: 'Task marked as completed', timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'success' })
        this.bindTaskList();
      }
      else {
        this.Toast.addToast({ title: 'Error Occurred', msg: "Task Status Updatation Failed", timeout: 5000, theme: 'bootstrap', position: 'bottom-right', type: 'error' })
      }
    });
  }

  ngOnInit() {
    this.IsConnectedExchange = false;
    this.user = this.authService.user != null ? this.authService.user : "";
    if (!this.Validation.IsinValid(this.exchangeSelected) && this.exchangeSelected > 0) {
      this.selectedExchange = this.exchangeSelected;
      this.bindChart();
    }
    //Below code will execute when 1031 user changes his current 1031 exchange from 1031-exchange-selector component
    this.Shared.exchangeSelection.subscribe(res => {
      this.selectedExchange = res;
      if (this.selectedExchange > 0 && this.blockChartRebind) {
        this.bindChart();
      }
      this.blockChartRebind = true;
    });

    this.Trade1031.GetExchangeGuid(this.exchangeSelected).subscribe(res => {
      this.exchangeGuid = res;
      this.Trade1031.Get1031ExchangeDetailsForEdit(res).subscribe(response => {
        this.exchangeInfo = response;
        if (this.exchangeInfo["Sold_ProjectedSaleDate"] === null) {
          $("#divchart").hide();
        }
      });
    });
  }

  exchangeGuid = "";
  exchangeInfo = [];
  itemCount = 0;
  height = 0;
  tradeStart: number;

  tradeStartDate: Date;
  tradeEndDate: Date;
  Titles = [''];
  plotBands = [];
  bindChart() {
    this.blockChartRebind = false;

    ///this.initializeChart();
    this.currentDate = this.Validation.getCurrentDate();
    //this.chart = new Chart();
    this.chartDataResponse = [];
    this.chartData = [];

    this.offerService.GetOfferProgressByExchangeId(this.selectedExchange).subscribe(res => {
      this.chartDataResponse = res;
      if (this.chartDataResponse.length > 0) {
        this.chartHeight = ((this.chartDataResponse.length / 5) * 100) - (this.chartDataResponse.length * 10);
        if (this.chartHeight < 200) {
          this.chartHeight = 200;
        }
        this.tradeStart = this.Validation.convertDateToUTCStamp(this.chartDataResponse[0].TradeStartDate);

        this.tradeStartDate = this.Validation.convertUTCDateToLocalDate(this.chartDataResponse[0].TradeStartDate);
        this.tradeEndDate = this.Validation.DateAdd(this.tradeStartDate, 180);
      }

      let count = 1;
      this.Titles = [''];
      let legendList = [];
      let highdate = 0;
      let prevTitleId = 0;
      let index = 0;
      this.endDate = 0;

      let endDateSearch: Date = null;
      let startDateSearch: Date = null;
      if (this.chartDataResponse.length > 0) {
        endDateSearch = null;
        startDateSearch = new Date(this.chartDataResponse[0].StartDate);
        this.chartDataResponse.forEach(item => {
          if (new Date(item.EndDate) > endDateSearch) {
            endDateSearch = new Date(item.EndDate);
          }
          if (new Date(item.StartDate) < startDateSearch) {
            startDateSearch = new Date(item.StartDate);
          }
        });
        this.endDate = this.Validation.convertDateToUTCStamp(endDateSearch);
        this.startDate = this.Validation.convertDateToUTCStamp(startDateSearch);
        this.date_45 = this.tradeStart + (24 * 3600 * 1000 * 45);
        this.chartDataResponse.forEach(item => {
          if (prevTitleId !== item.TitleId) {
            prevTitleId = item.TitleId;
            let phase = this.chartDataResponse.filter(x => x.TitleId == prevTitleId);
            this.Titles.push("<div style='text-align: right;'><b>" + item.TitleName + "</b></div><div style='text-align: right;font-weight: normal;font-size: 12px;'>" + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(item.StartDate))) + " - " + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(phase[phase.length - 1].EndDate)))+ "</div>");
            index = index + 1;
            this.itemCount++;
          }

          highdate = this.Validation.convertDateToUTCStamp(item.EndDate);
          let lowDate = 0;
          lowDate = this.Validation.convertDateToUTCStamp(item.StartDate);
          let HoverText = "Start Date :" + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(item.StartDate))) +
            " End Date :" + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(item.EndDate)));

          //if (count == 1) {
          //    this.startDate = lowDate;
          //    this.date_45 = this.tradeStart + (24 * 3600 * 1000 * 45);
          //    const uptotoday = {
          //        name: "SUB",
          //        color: "#81a4bf",
          //        pointWidth: 10,
          //        showInLegend: false,
          //        data: [{
          //            x: 0,
          //            low: this.startDate < this.tradeStart ? this.startDate : this.tradeStart,
          //            high: this.currentDate,
          //            hoverText: "In progress",
          //        }],
          //    };
          //    this.chart.addSerie(uptotoday);
          //}

          //if (count == 1) {
          //    this.startDate = lowDate;
          //    this.date_45 = this.tradeStart + (24 * 3600 * 1000 * 45);
          //}

          const singleData = {
            name: this.Validation.getTaskPhaseName(item.Id, item.Name),
            color: this.getChartColor(item.Id),
            pointWidth: 25,
            showInLegend: legendList.indexOf(item.Name) > -1 ? false : true,
            data: [{
              x: index,
              low: lowDate,
              high: highdate,
              hoverText: HoverText,
            }],
          };
          legendList.push(item.Name);
          this.chartData.push(singleData);

          //if (count == this.chartDataResponse.length) {
          //    const coming = {
          //        name: "SUB",
          //        color: "#e6e6e6",
          //        pointWidth: 10,
          //        showInLegend: false,
          //        data: [{
          //            x: 0,
          //            low: this.currentDate,
          //            high: this.endDate,
          //            hoverText: "Upcoming",
          //        }],
          //    };
          //    this.chart.addSerie(coming);
          //}
          count++;
        });
        this.plotBands = [
          {
            color: '#c0211f',
            from: this.currentDate,
            to: this.currentDate,
            label: {
              text: '<div><b>Today </b></div>' + (this.Validation.IsinValid(this.currentDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.currentDate)))),
              verticalAlign: 'top',
              y: this.chartHeight - 20,
              align: this.setCurrentDatePosition(this.currentDate, this.endDate, this.currentDate) ? 'right' : 'left',
              x: this.setCurrentDatePosition(this.currentDate, this.endDate, this.currentDate) ? -5 : 5,
              style: {
                fontSize: '11px',
                whiteSpace: 'nowrap',
                overflow: 'visible',
                textOverflow: 'none',
                width: 'auto'
              }
            }
          },
          {
            color: '#bd2765',
            from: this.date_45,
            to: this.date_45,
            label: {
              text: '<div><b>Identification Period </b></div> ' + (this.Validation.IsinValid(this.date_45) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.date_45)))),
              align: 'left',
              verticalAlign: 'top',
              y: 0,
              x: 4,
              style: {
                fontSize: '11px',
                whiteSpace: 'nowrap',
                overflow: 'visible',
                textOverflow: 'none',
                width: 'auto'
              }
            }
          }
        ];

        this.populateGraph();
      }
      else {
        if (this.exchangeSelected > 0) {
          this.Trade1031.GetExchangeDetails(this.exchangeSelected, this.user.Id).subscribe(res => {

            this.tradeStartDate = this.Validation.convertUTCDateToLocalDate(res.ProjectedSaleDate);
            this.tradeEndDate = this.Validation.DateAdd(this.tradeStartDate, 180);

            this.tradeStart = this.Validation.convertDateToUTCStamp(res.ProjectedSaleDate);
            this.tradeStart = moment(res.ProjectedSaleDate).unix() * 1000;
            this.startDate = this.tradeStart;

            this.endDate = moment(moment(moment(res.ProjectedSaleDate).unix() * 1000).add(180, 'days')).unix() * 1000
            this.date_45 = this.tradeStart + (24 * 3600 * 1000 * 45);
            const uptotoday = {
              name: "SUB",
              color: "#81a4bf",
              pointWidth: 25,
              showInLegend: false,
              data: [{
                x: 0,
                low: this.tradeStart,
                high: this.currentDate,
                hoverText: "In progress",
              }],
            };
            this.chartData.push(uptotoday);
            const coming = {
              name: "SUB",
              color: " #cccccc",
              pointWidth: 25,

              showInLegend: false,
              data: [{
                x: 0,
                low: this.currentDate,
                high: this.endDate,
                hoverText: "Upcoming",
              }],
            };
            this.chartData.push(coming);
            this.plotBands = [{
              color: '#ffffff',
              from: this.startDate,
              to: this.startDate,
              label: {
                text: '<div><b>Trade Start</b></div><br>' + this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.startDate))),
                align: 'left',
                x: 5,
                style: {
                  fontSize: '11px',
                  whiteSpace: 'nowrap',
                  overflow: 'visible',
                  textOverflow: 'none',
                  width: 'auto'
                }
              }
            },
            {
              color: '#c0211f',
              from: this.currentDate,
              to: this.currentDate,
              label: {
                text: '<div><b>Today</b></div><br>' + (this.Validation.IsinValid(this.currentDate) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.currentDate)))),
                align: this.setCurrentDatePosition(this.currentDate, this.endDate, this.currentDate) ? 'right' : 'left',
                x: this.setCurrentDatePosition(this.currentDate, this.endDate, this.currentDate) ? -5 : 5,
                verticalAlign: 'top',
                y: this.chartHeight - 40,
                style: {
                  fontSize: '11px',
                  whiteSpace: 'nowrap',
                  overflow: 'visible',
                  textOverflow: 'none',
                  width: 'auto'
                }
              }
            },
            {
              color: '#bd2765',
              from: this.date_45,
              to: this.date_45,
              label: {
                text: '<div><b>Identification Period</b></div><br>' + (this.Validation.IsinValid(this.date_45) ? '' : this.Validation.formatDatetoMMDDYYYY(this.Validation.convertUTCDateToLocalDate(new Date(this.date_45)))),
                align: 'left',
                verticalAlign: 'top',
                y: 9,
                x: 4,
                style: {
                  fontSize: '11px',
                  whiteSpace: 'nowrap',
                  overflow: 'visible',
                  textOverflow: 'none',
                  width: 'auto'
                }
              }
            },
            {
              color: '#ffffff',
              from: this.endDate,
              to: this.endDate,
              label: {
                text: '<div><b>Trade End</b></div> ' + moment(this.endDate).local().format("MM/DD/YYYY"),
                align: 'right',
                x: -5,
                useHTML: true,
                style: {
                  fontSize: '11px',
                  whiteSpace: 'nowrap',
                  overflow: 'visible',
                  textOverflow: 'none',
                  width: 'auto'
                }
              }
            }
            ];

            this.populateGraph();
          });
        }
      }

      //this.closeDate.emit(this.Validation.convertUTCDateToLocalDate(new Date(this.endDate)));

    });

    this.bindTaskList();
  }

  setCurrentDatePosition(startDate: number, endDate: number, currentDate: number) {
    if ((endDate - currentDate) <= 172800000) {
      return true;
    }
    return false;
  }
  bindTaskList() {
    this.offerService.GetTaskSummaryFordashboard(this.exchangeSelected).subscribe(res => {
      this.TaskSummary = res;
      this.taskHeaders = this.TaskSummary.filter(x => x.Id == -3 || x.Id == -2 || x.Id == -1);
      this.TaskSummaryHeaders = this.TaskSummary.filter(x => (x.Id !== -3 && x.Id !== -2 && x.Id !== -1 && x.Type == 0));
      this.TaskSummary = res.filter(x => x.Type === 1);
      this.TaskSummary.forEach(item => {
        item.StartDate = this.Validation.convertUTCDateToLocalDate(item.StartDate);
        item.EndDate = this.Validation.convertUTCDateToLocalDate(item.EndDate);
      });

    });
  }
  filterTask(propertyid) {
    return this.TaskSummary.filter(x => x.Id === propertyid);
  }

  TaskSummaryHeaders: ITaskSummary[];
  taskHeaders: ITaskSummary[];

  chartHeight = 200;

  populateGraph() {
    $("#divchart").css("max-height", this.chartHeight + "px");
    console.log(this.chartData);
    this.options = {
      chart: {
        type: 'columnrange',
        inverted: true,
        height: this.chartHeight,
      },
      boost: {
        seriesThreshold: 5000,
        useGPUTranslations: false,
      },
      title: {
        text: ""
      },
      xAxis: {
        categories: this.Titles,
        type: '',
        title: {
          text: ''
        },
        scrollbar: {
          enabled: true
        },
        labels: {
          useHTML: true,
          style: {
            fontSize: '12px',
           
          }
        }
      },
      yAxis: {
        title: {
          text: ''
        },
        type: 'datetime',
        min: this.startDate,
        max: this.endDate,
        scrollbar: {
          enabled: true
        },
        dateTimeLabelFormats: {
          day: '%e %b %y',
          month: "%b-%y"
        },
        labels: {
          format: '{value:%m-%e-%Y}',
          enabled: false,
          style: {
            fontSize: '14px'
          }
        },
        plotBands: this.plotBands,
        tickPositions: [this.startDate, this.date_45, this.currentDate, this.endDate]
      },
      legend: {
        enabled: false,
      },
      bar: {
        groupPadding: 0,
        pointPadding: 0,
      },
      plotOptions: {
        columnrange: {
          grouping: false,
        },
        series: {
          stacking: 'normal',
          events: {
            legendItemClick: function () {
              return false;
            }
          },
          dataLabels: {
            enabled: true,
            align: 'center',
            color: '#000000',
            x: -10,
            style: {
              fontSize: '14px'
            },
            formatter: function () {
              if (this.series.name != "SUB") {
                return '<b>' + this.series.name.split('-')[0] + '</b>';
              }
              else {
                return '';
              }
            }
          },
        },
      },
      series: this.chartData,
      exporting: {
        enabled: false
      },
      credits: {
        enabled: false
      },
      tooltip: {
        style: {
          fontSize: '14px'
        },
        formatter: function () {
          let index = this.series.data.indexOf(this.point);
          if (this.series.name != "SUB") {
            let name = [] = this.series.name.split('-');
            return '<b>' + name[name.length - 1] + '</b> <br>' + this.series.data[index].hoverText
          }
          else {
            return false;
          }
        }
      }
    }
    Highcharts.chart('divchart', this.options);

    this.IdPeriodDays = this.Validation.DateDiff(this.Validation.convertUTCDateToLocalDate(new Date(this.currentDate)), this.Validation.convertUTCDateToLocalDate(new Date(this.date_45)));
    if (this.IdPeriodDays < 0) {
      this.IdPeriodDays = 0;
    }
    let ActulaCloseDate = this.Validation.DateAdd(new Date(this.tradeStart), 180);
    this.ClosingPeriodDays = this.Validation.DateDiff(this.Validation.convertUTCDateToLocalDate(new Date(this.currentDate)), this.Validation.convertUTCDateToLocalDate(ActulaCloseDate));
    if (this.ClosingPeriodDays < 0) {
      this.ClosingPeriodDays = 0;
    }
  }

  IdPeriodDays = 0;
  ClosingPeriodDays = 0;
  onViewOffers() {
    window.scrollTo(0, 0);
    this.changeActiveTab.emit("offers");
  }

  getChartColor(phaseid) {
    const colors = [' #A7A8A9 ', ' #003A5D ', ' #02C29F ', ' #FFC32B ', ' #FF4438 ']
    switch (phaseid) {
      case 2300: {
        return colors[0];
      }
      case 2301: {
        return colors[1];
      }
      case 2302: {
        return colors[2];
      }
      case 2303: {
        return colors[3];
      }
      case 2304: {
        return colors[4];
      }
      case 350: {
        return "#5bc7af";
      }
      default: {
        return "#5bc7af";
      }
    }
  }
  //colorPicker(legendId: number) {
  //    if (legendId == 2300) {
  //        return "#5bc7af";
  //    }
  //    else if (legendId == 2301) {
  //        return "#78b7f2";
  //    }
  //    else if (legendId == 2302) {
  //        return "#9791d4";
  //    }
  //    else if (legendId == 2303) {
  //        return "#EFC36D";
  //    }
  //    else if (legendId == 2304) {
  //        return "#d9a78c";
  //    }
  //}

}
